import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'arrayFilter',
    pure: false
})
export class ArrayFilterPipe implements PipeTransform {
    transform(items: any[], thisRef: any, callback: (item: any, thisRef: any) => boolean): any {
        if (!items || !callback) {
            return items;
        }
        return items.filter((item) => callback(item, thisRef));
    }
}
